import * as React from 'react';
import Button from '@material-ui/core/Button';
import Stack from '@mui/material/Stack';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

function DownloadHistoricalFinancialOptionGuest() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <span>
      <span className="card-description"></span>
      <Stack direction="row" spacing={2}>
      <div><p className="card-description"><CloudDownloadIcon fontSize="small" /> <a href='' onClick={handleClickOpen} >CSV</a> | <a href='' onClick={handleClickOpen}>JSON</a></p></div>
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Want to perform this operation?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Sign in to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button autoFocus variant="outlined" onClick={ handleClose }>
                Cancel
              </Button>
              <Button href="/signin" variant="outlined">Sign in</Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Stack>
    </span>
  );
}

function DownloadHistoricalFinancialOptionFreePlan() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <span>
      <span className="card-description"></span>
      <Stack direction="row" spacing={2}>
        <div><p className="card-description"><CloudDownloadIcon fontSize="small" /> <a href='' onClick={handleClickOpen} >CSV</a> | <a href='' onClick={handleClickOpen}>JSON</a></p></div>
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Want to perform this operation?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Upgrade to premium to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button autoFocus variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button href="/pricing" variant="outlined">Upgrade</Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Stack>
    </span>
  );
}


function DownloadHistoricalFinancialOption({data} :any) {
  const user_state = data.user_state;

  if (user_state?.status == 'guest') {
    return <DownloadHistoricalFinancialOptionGuest />;
  } else if (user_state?.status == 'premium') {
    return <div><p className="card-description"><CloudDownloadIcon fontSize="small" /> <a href={"/ticker/" + data.ticker + "/financials/download.csv"}>CSV</a> | <a href={"/ticker/" + data.ticker + "/financials/download.json"}>JSON</a></p></div>;
  } else if (user_state?.status == 'free_plan') {
    return <DownloadHistoricalFinancialOptionFreePlan />;
  } else {
    return <div><p className="card-description"><CloudDownloadIcon fontSize="small" /> <a href={"/ticker/" + data.ticker + "/financials/download.csv"}>CSV</a> | <a href={"/ticker/" + data.ticker + "/financials/download.json"}>JSON</a></p></div>
  }
}

export default DownloadHistoricalFinancialOption;
